import { createClient } from '@supabase/supabase-js'
import { SERVICES_ANON_KEY, SERVICES_URL } from './constants'

if (!SERVICES_URL || !SERVICES_ANON_KEY) {
    throw new Error(`make sure the SERVICES_URL and SERVICES_ANON_KEY environment variables are defined`)
}

export const supabase = createClient(SERVICES_URL, SERVICES_ANON_KEY)